<template>
	<div class="box">
		<LoadingSpinner v-if="loading" />
		<div v-else>
			<!-- État connecté -->
			<div v-if="accounting && accounting.accountingplan_superpdp_connected">
				<b-alert variant="success" show>
					{{ $t('compta.superpdp.connected') }}
					<span v-if="accounting.accountingplan_superpdp_connected_at">
						({{ formatDate(accounting.accountingplan_superpdp_connected_at) }})
					</span>
				</b-alert>
				<b-button variant="danger" :disabled="processing" @click="disconnect">{{ $t('compta.superpdp.disconnect') }}</b-button>
			</div>

			<!-- État connexion en cours : QR code + lien + polling -->
			<div v-else-if="onboarding">
				<p>{{ $t('compta.superpdp.scan_qr') }}</p>
				<img v-if="onboarding.qr_code" :src="'data:image/png;base64,' + onboarding.qr_code" alt="QR code SUPER PDP" class="superpdp-qr" />
				<p class="mt-3">
					<a :href="onboarding.authorize_url" rel="noopener">{{ $t('compta.superpdp.open_link') }}</a>
				</p>
				<p class="text-muted">{{ $t('compta.superpdp.waiting') }}</p>
			</div>

			<!-- État initial : bouton de connexion + pré-requis -->
			<div v-else>
				<b-alert v-if="error_message" variant="danger" show class="mb-2">
					{{ $t('compta.superpdp.error') }}
					<span v-if="error_message !== '1'">{{ error_message }}</span>
				</b-alert>
				<b-button variant="primary" :disabled="!can_active || processing" @click="connect">{{ $t('compta.superpdp.connect') }}</b-button>
				<b-alert v-if="!can_active" variant="danger" show class="mt-2">
					{{ $t('compta.superpdp.cant_connect') }}
					<ul>
						<li v-if="!accounting.tiers.tiers_mail">{{ $t('compta.superpdp.missing_mail') }}</li>
						<li v-if="!accounting.tiers.tiers_siren">{{ $t('compta.superpdp.missing_siren') }}</li>
					</ul>
				</b-alert>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import Accounting from "@/mixins/Accounting.js"

	export default {
		name: 'AccountingSuperPDP',
		mixins: [Accounting],
		props: ['accountingplan_id'],
		data () {
			return {
				accounting: null,
				loading: true,
				processing: false,
				onboarding: null,
				poll_interval: null,
				error_message: this.$route.query.superpdp_error || null
			}
		},

		mounted() {
			this.init_component()
		},

		beforeDestroy() {
			this.stopPolling()
		},

		methods: {
			async init_component() {
				this.loading = true
				this.accounting = await this.loadAccountingPlan(this.accountingplan_id)
				this.loading = false
			},

			async connect() {
				if(this.processing) return false
				this.processing = true
				this.error_message = null
				this.onboarding = await this.startSuperPDPOnboarding(this.accountingplan_id)
				this.processing = false

				if(this.onboarding) {
					this.startPolling()
				}
			},

			async disconnect() {
				if(this.processing) return false
				this.processing = true
				await this.disconnectSuperPDP(this.accountingplan_id)
				this.processing = false
				this.init_component()
			},

			// Interroge le statut d'onboarding jusqu'à la connexion effective (scénario cross-device).
			startPolling() {
				this.stopPolling()
				this.poll_interval = setInterval(async () => {
					const result = await this.getSuperPDPStatus(this.accountingplan_id)
					if(result && result.status === 'connected') {
						this.stopPolling()
						this.onboarding = null
						this.init_component()
					}
					else if(result && result.status === 'expired') {
						this.stopPolling()
						this.onboarding = null
					}
				}, 4000)
			},

			stopPolling() {
				if(this.poll_interval) {
					clearInterval(this.poll_interval)
					this.poll_interval = null
				}
			}
		},

		computed: {
			can_active() {
				return this.accounting && this.accounting.tiers.tiers_mail && this.accounting.tiers.tiers_siren
			}
		},

		components: {
			LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
		}
	}

</script>
